import memoize from 'lodash/memoize';
import isNull from 'lodash/isNull';
import messages from './messages';
import {
  InstructionSource,
  RetirementAccountType,
  IRADistributionReason,
  MarginCallType,
  TransferType,
} from './constants';

function formatDollars(dollars = 0) {
  if (isNull(dollars)) {
    return '$0.00';
  }
  return `$${dollars.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;
}

const titleCase = (str = '') =>
  str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

const formatTitleCase = memoize(titleCase);

const betweenParentheses = / *\([^)]*\) */g;
const formatCorrespondentName = memoize((str = '') => {
  // Title case all but the correspondent code from the name. Backend is concatenating it.
  if (str) {
    const name = titleCase(str.replace(betweenParentheses, ''));
    const correspondentCode = str.match(betweenParentheses);
    return `${name}${correspondentCode || ''}`;
  }
  return '';
});

const formatTransferState = memoize((str = '') =>
  messages[`transferState${str}`] ? messages[`transferState${str}`].defaultMessage : '',
);

const formatInstructionSource = (val) => InstructionSource[val] || val;

const formatRetirementAccountType = (val) => RetirementAccountType[val] || val;

const formatIRADistributionReason = (val) => IRADistributionReason[val] || val;

const formatMarginCallType = (val) => MarginCallType[val] || val;

const formatTransferType = (val) => TransferType[val] || val;

export default {
  formatDollars,
  formatIRADistributionReason,
  formatTitleCase,
  formatCorrespondentName,
  formatInstructionSource,
  formatMarginCallType,
  formatRetirementAccountType,
  formatTransferState,
  formatTransferType,
};



// WEBPACK FOOTER //
// ./src/common/formatters.js